import { ChangeDetectorRef, Directive, inject, OnChanges, OnInit, ViewRef } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { ICmsDataChangeService } from '@icms/core/data/change/icms-data-change.service';
import { Subscription } from 'rxjs';
import { IPageFooterColumn, IPageFooterColumnMobile } from './page-footer.component';
@Directive()
export class AbstractPageFooterColumnComponent implements OnInit, OnChanges {
    private iCmsDataChangeService = inject(ICmsDataChangeService);
    column!: IPageFooterColumn | IPageFooterColumnMobile;
    private initiated = false;
    /**
     * Component subscriptiosn
     */
    private subscriptions = new Subscription();
    constructor(
        private _ref: ChangeDetectorRef,
        private timeoutService: TimeoutService
    ) {
        _ref.detach();
    }
    ngOnInit() {
        this.initiated = true;
        this.iCmsDataChangeService.afterChange$.subscribe(x => {
            if (x.changedObject === this.column) {
                this.detectChanges();
            }
        });
        this.detectChanges();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    ngOnChanges() {
        this.detectChanges();
    }
    private detectChanges() {
        if (this.initiated) {
            this.timeoutService.async(() => {
                if (!(<ViewRef>this._ref).destroyed) {
                    this._ref.detectChanges();
                }
            });
        }
    }
}
